import { render, staticRenderFns } from "./Orderpurchaseedit.vue?vue&type=template&id=3f526158&scoped=true"
import script from "./Orderpurchaseedit.vue?vue&type=script&lang=js"
export * from "./Orderpurchaseedit.vue?vue&type=script&lang=js"
import style0 from "./Orderpurchaseedit.vue?vue&type=style&index=0&id=3f526158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f526158",
  null
  
)

export default component.exports